import apiClient from './apiClient';

const holidayService = {
  /**
   * Get all holidays
   */
  getAll: async ({ year = null, category, organizationId, page = 1, limit = 50 } = {}) => {
    let url = `/holidays?page=${page}&limit=${limit}`;

    if (year) {
      url += `&year=${year}`;
    }

    if (category) {
      url += `&category=${encodeURIComponent(category)}`;
    }

    if (organizationId) {
      url += `&organizationId=${organizationId}`;
    }

    const response = await apiClient.get(url);
    return response.data;
  },

  /**
   * Create holiday
   */
  create: async (holidayData) => {
    const response = await apiClient.post('/holidays', holidayData);
    return response.data;
  },

  /**
   * Update holiday
   */
  update: async (id, holidayData) => {
    const response = await apiClient.put(`/holidays/${id}`, holidayData);
    return response.data;
  },

  /**
   * Delete holiday
   */
  delete: async (id) => {
    const response = await apiClient.delete(`/holidays/${id}`);
    return response.data;
  }
};

export default holidayService;
